"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDKEventType = void 0;
var SDKEventType;
(function (SDKEventType) {
    SDKEventType["Focus"] = "FOCUS";
    SDKEventType["SDKMetadata"] = "SDKMETADATA";
    SDKEventType["ImageInput"] = "IMAGE_INPUT";
    SDKEventType["Success"] = "SUCCESS";
    SDKEventType["Fail"] = "FAIL";
})(SDKEventType || (exports.SDKEventType = SDKEventType = {}));
//# sourceMappingURL=SdkEventType.js.map